export const resolveWithRovoFeature = 'resolve-with-rovo' as const;
export const RESOLVE_WITH_ROVO_FEATURE: ResolveWithRovoFeature = resolveWithRovoFeature;
export type ResolveWithRovoFeature = 'resolve-with-rovo';
